module.exports = __webpack_public_path__ + "img/images.f4f5e6df.svg";